import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './reducers/store';
import { initAppInsights } from './services/appInsights';
import { initSentry } from './services/sentry';
import './styles/tailwind.css';

initSentry();
initAppInsights();

createRoot(document.getElementById('root')).render(
  <Router>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>
);